module.exports = __webpack_public_path__ + "img/cart.3a4f0e3c.svg";